export { formatTemplate as default } from 'choerodon-ui/dataset';
